module.exports = __webpack_public_path__ + "app/modals/wz-change-customer-modal.view.html";